import COUNTRY_MAPPINGS from '../../../lib/country_mappings.json'

const SCRIPT_URL = `//geoip-js.com/js/apis/geoip2/v2.1/geoip2.js`

export const loadGeopIP = () => {
  const head = document.querySelector('head')

  return new Promise((resolve, reject) => {
    if (!window.geoip2) {
      const scriptTag = document.createElement('script')
      scriptTag.src = SCRIPT_URL
      scriptTag.onload = () => resolve(window.geoip2)

      head.appendChild(scriptTag)
    } else {
      resolve(window.geoip2) 
    }
  })
}

const mapCountry = geoipResponse => {
  const { country } = geoipResponse
  const { iso_code } = country
  const countryName = COUNTRY_MAPPINGS[iso_code]
  return countryName
}

const getCountry = geoip2 => {
  const { country } = geoip2
  return new Promise((resolve, reject) => {
    const onSuccess = res => resolve(mapCountry(res))
    const onError = console.log

    country(onSuccess, onError)
  })
}

export const getGeoIPCountry = async () => {
  const geoip2 = await loadGeopIP()
  const country = await getCountry(geoip2)
  return country
}
